import { Link } from "react-router-dom";
import { getCachedMediaUrl } from "../../../../lib/utils/utils";

function ProductDetails({orderDetails}) {
  return (
    <div className="border border-[#EAEAEA] rounded-lg px-4 py-3 bg-[#FFFFFF] flex flex-col gap-2">
      <h1 className="font-semibold text-base text-[#666666]">
        Product Details
      </h1>

      <div className="flex flex-col">
        <div className="flex w-full uppercase bg-[#F5F5F5] font-semibold text-[14px] leading-6 text-[#666666]">
          <h1 className="w-[60%] px-[10px] py-2">product</h1>
          <h1 className="w-[15%] px-[10px] py-2">quantity</h1>
          <h1 className="w-[25%] px-[10px] py-2">rate per qty</h1>
        </div>

        <div className="flex items-center w-full border-t border-[#EAEAEA]">
          <div className="w-[60%] px-[10px] py-[6px] flex gap-2 items-center">
            <div className="size-16 rounded-lg overflow-hidden">
              <img
                className="size-full object-cover"
                src={getCachedMediaUrl(
                  orderDetails?.["Variant.VarientImgUrl"]?.[0]
                )}
                alt=""
              />
            </div>

            <div className="flex flex-col gap-1 w-[calc(100%-64px-11px)]">
              <Link
                to={`/inventory-management/product/${orderDetails["Product.id"]}`}
                className="font-semibold text-[14px] leading-6 text-[#121212] whitespace-nowrap overflow-hidden text-ellipsis"
              >
                {orderDetails?.["Variant.VarientName"] ?? orderDetails?.["Product.productName"]}
              </Link>

              <p className="flex gap-1 items-center text-[#666666] font-medium">
                <span className="text-[12px] leading-6">
                  Size: {orderDetails?.["Variant.VarientSize"]}
                </span>
                <span className="text-[12px] leading-6">
                  Color: {orderDetails?.["Variant.VarientColor"]}
                </span>
              </p>
            </div>
          </div>

          <div className="w-[15%] px-[10px] py-[26px]">
            <h1 className="font-medium text-[14px] leading-6">
              {orderDetails.quantity}
            </h1>
          </div>

          <div className="w-[25%] px-[10px] py-[26px]">
            <h1 className="font-medium text-[14px] leading-6">
              ₹{orderDetails?.["Product.productSellingPrice"]}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails;
